let labels = {
    accountType: 'POS Setup',
    category: 'Category',
	orderSource: 'Industry/Business Type',
};

export default labels;
